const state = {
  trackingData: {}
}

const getters = {
  trackingData: state => state.trackingData
}

const mutations = {
  setTrackingData (state, data) {
    state.trackingData = {
      ...state.trackingData,
      ...data,
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tracking.js